import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import type {
  CategoryEnum,
  CGCustomComponents,
  CGInputs,
  ConfigurationResourceReadFront,
  ReactConfigurationGeneratorApi,
} from '@ingenico/react-configuration-generator';
import { ReactConfigurationGeneratorBuilder } from '@ingenico/react-configuration-generator';
import type { FormBuilderHandle } from '@ingenico/react-form-builder';
import type { DeepPartialBy } from '@ingenico/util-common';
import deepEqual from 'fast-deep-equal';
import type { ForwardedRef, ReactElement, ReactNode, RefObject } from 'react';
import { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfigurationFormBuilderWrapperV2 } from './useConfigurationFormBuilderWrapperV2.vm';

export interface ConfigurationFormBuilderWrapperProps {
  readonly inputs: DeepPartialBy<
    CGInputs,
    'actions' | 'fgComponents' | 'fgTranslations' | 'isEditEnabled' | 'translations'
  >;
  readonly initialCategory?: CategoryEnum;
  readonly customComponents?: CGCustomComponents;
  readonly initialConfiguration?: ConfigurationResourceReadFront;
  readonly formBuilderRef: RefObject<FormBuilderHandle>;
  readonly headerAction?: ReactNode;
}

function ConfigurationFormBuilderWrapperCpntV2(
  {
    inputs,
    initialCategory,
    customComponents,
    initialConfiguration,
    formBuilderRef,
    headerAction,
  }: ConfigurationFormBuilderWrapperProps,
  ref: ForwardedRef<ReactConfigurationGeneratorApi>,
): ReactElement {
  const { t, i18n } = useTranslation([ALL_LNGS_NAMESPACES.CONFIGURATION_PROFILE, ALL_LNGS_NAMESPACES.COMMON]);
  const { apiFnList, navigationFnList, mappedInputs, reactConfigurationGeneratorRef } =
    useConfigurationFormBuilderWrapperV2({ inputs, t, i18n, initialConfiguration }, ref);

  return (
    <ReactConfigurationGeneratorBuilder
      apiFnList={apiFnList}
      initialCategory={initialCategory}
      inputs={mappedInputs}
      navigationFnList={navigationFnList}
      ref={reactConfigurationGeneratorRef}
      customComponents={customComponents}
      formBuilderRef={formBuilderRef}
      headerAction={headerAction}
    ></ReactConfigurationGeneratorBuilder>
  );
}

export const ConfigurationFormBuilderWrapperV2 = memo(forwardRef(ConfigurationFormBuilderWrapperCpntV2), deepEqual);
